import { z } from 'zod';
/** Identifiant technique : UUID (v7 côté serveur). Jamais un numéro métier. */
export const Uuid = z.string().uuid();
export const IsoDateTime = z.string().datetime({ offset: true });
export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Format attendu : AAAA-MM-JJ');
export const Locale = z.enum(['fr', 'en']);
/** Téléphone au format E.164 (ex. +22678823238). */
export const PhoneE164 = z
    .string()
    .regex(/^\+[1-9]\d{6,14}$/, 'Numéro au format international (+226…)');
export const Email = z
    .string()
    .email()
    .max(254)
    .transform((v) => v.trim().toLowerCase());
/**
 * Drapeau booléen porté par une query string.
 *
 * `z.coerce.boolean()` ne convient pas : il rend `true` pour la chaîne `"false"`,
 * alors que le client envoie littéralement `?includeInactive=false`.
 */
export const QueryBoolean = z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .transform((value) => value === true || value === 'true' || value === '1');
/** Pagination par curseur (réponses de liste). */
export const CursorPageQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(25),
    cursor: z.string().max(512).optional(),
});
export const PageInfo = z.object({
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int(),
});
export function pagedResponse(item) {
    return z.object({ data: z.array(item), page: PageInfo });
}
export function dataResponse(item) {
    return z.object({ data: item });
}
/** Champs d'audit communs à toutes les entités exposées. */
export const AuditedFields = z.object({
    createdAt: IsoDateTime,
    updatedAt: IsoDateTime,
});
/** Verrou optimiste : version entière incrémentée à chaque modification. */
export const Version = z.number().int().nonnegative();
//# sourceMappingURL=common.js.map